import moment from 'moment';
import { Http } from '../../../support';

const from = moment().subtract(1, 'month').format('YYYY-MM-DD');
const to = moment().format('YYYY-MM-DD');

const initialState = {
  busy: false,
  data: [],
  error: undefined,
  pagination: {
    limit: 25,
    from,
    to,
  },
  filters: {
    search: '',
  },
};

const paginate = async (store, meta = {}) => {
  store.setState((state) => {
    state.admin.dashboard.list.busy = true;
  });

  try {
    const params = {
      ...meta,
    };

    const headers = {
      'X-Tenancy': 'fa/live',
    };

    const response = await Http.get('api/admin/dashboard/consumo', { params, headers });

    store.setState((state) => {
      state.admin.dashboard.list.busy = false;
      state.admin.dashboard.list.data = response.data;
      state.admin.dashboard.list.pagination = {
        ...state.admin.dashboard.list.pagination,
        ...response.meta.pagination,
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.admin.dashboard.list.error = error.data || error;
      state.admin.dashboard.list.busy = false;
    });
  }
};

const resetError = (store) => (state) => {
  state.admin.dashboard.list.error = undefined;
};

const reset = (store) => (state) => {
  state.admin.dashboard.list = { ...initialState };
};

const DashboardListStore = {
  state: () => initialState,
  actions: {
    paginate,
    resetError,
    reset,
  },
};

export default DashboardListStore;
